<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters text-left justify-content-between">
      <div class="col-12 col-md-auto pr-5">
        <h4 class="font-weight-bold mb-0">Vessel List</h4>
      </div>
      <div class="col-12 col-md-auto">
        <div class="row">
          <div v-if="!this.authUser.manningId" class="form-group form-inline">
            <label for="VesselManningFilter" class="mr-2 font-weight-bold">Manning: </label>
            <select class="form-control form-control-sm mr-5"
                    id="VesselManningFilter"
                    v-model="formDataVesselTon.manningId"
                    :disabled="isLoading"
                    @change="searchVessel">
              <option :value="null">-- All --</option>
              <option :value="manning.id" v-for="(manning,index) in objManningKeys" :key="manning.id">
                <span>{{ manning.alias ? manning.alias.toUpperCase() : '--' }}</span>
              </option>
            </select>
          </div>

          <div class="form-group form-inline">
            <label for="VesselTypeFilter" class="mr-2 font-weight-bold">Type: </label>
            <select class="form-control form-control-sm"
                    id="VesselTypeFilter"
                    :disabled="isLoading"
                    v-model="formDataVesselTon.vesselType"
                    @change="searchVessel">
              <option :value="null">-- All --</option>
              <option :value="type.id" v-for="(type,index) in objVesselTypeKeys" :key="type.id">
                <span>{{ type.name }}</span>
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-auto">
        <form @submit.prevent="searchVessel">
          <div class="input-group input-group-sm mb-3">
            <div class="input-group-prepend">
              <button type="submit" class="input-group-text" id="basic-addon1">
                &#128269;
              </button>
            </div>
            <input type="search"
                   @keyup="callSearchVesselDebounce"
                   class="form-control"
                   placeholder="Vessel Search"
                   aria-label="Vessel Search"
                   v-model="formDataVesselTon.searchVal"
                   :disabled="isLoading"
                   style="width: 300px !important;"
                   aria-describedby="basic-addon1">
          </div>
        </form>
      </div>
    </div>

    <div class="row no-gutters justify-content-between">
      <div class="col-12 col-md-auto">
        <base-pagination :page-object="vesselPagination" @settingPage="setPage" />
      </div>
      <div class="col-12 col-md-auto">
        <div class="form-group form-inline mb-0 pt-0 pr-0">
          <label for="count-vessel" class="col-form-label font-weight-bold mr-2">Count:</label>
          <select class="form-control form-control-sm" name="countVessel" id="count-vessel"
                  v-model="formDataVesselTon.count" @change="searchVessel">
            <option :value="count" v-for="(count,index) in counts" :key="index">
              <span>{{ count }}</span>
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-md-12">
        <base-table :max-height="600" :loading="isLoading" :loader-colspan="5">
          <template slot="table-header">
            <tr>
              <th scope="col" class="align-middle" style="width: 25% !important;">VESSEL NAME</th>
              <th scope="col" class="align-middle" style="width: 5% !important;">VESSEL CODE</th>
              <th scope="col" class="align-middle" style="width: 20% !important;">MANNING</th>
              <th scope="col" class="align-middle" style="width: 10% !important;">TYPE</th>
              <th scope="col" class="align-middle" style="width: 5% !important;">ACTION</th>
            </tr>
          </template>

          <template slot="table-body">
            <tr v-if="this.vessels.length == 0">
              <td colspan="5">No record found</td>
            </tr>
            <tr v-for="(vessel,index) in vessels" :key="vessel.id">
              <td class="align-middle text-left pl-4">{{ vessel.name }}</td>
              <td class="align-middle">{{ vessel.code }}</td>
              <td>
                <ul v-if="vessel.mannings.length > 1" class="list-group list-group-flush">
                  <li class="list-group-item text-left"
                      v-for="(man,index) in vessel.mannings">
                    <span :class="{'bg-warning' : formDataVesselTon.manningId == man.id}">
                    {{ man.alias ? man.alias.toUpperCase() : '' }}
                    </span>
                  </li>
                </ul>
                <span v-else>
                  {{vessel.mannings.alias ?vessel.mannings.alias.toUpperCase() : ''}}
                </span>
              </td>
              <td>
                <span v-if="vessel.type">{{ vessel.type ? vessel.type.toUpperCase() : '' }}</span>
              </td>
              <td class="align-middle">
                <base-info-btn @click.native="viewDetails(vessel)">
                  <font-awesome-icon icon="bars" />
                  <span class="ml-1">Details</span>
                </base-info-btn>
              </td>
            </tr>
          </template>
        </base-table>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {AppMixins} from '../../../mixins/app.mixins';
import __ from 'lodash'

export default {
  name: 'index',

  /** mixins **/
  mixins: [AppMixins],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {
    ...mapActions(
        [
          'getVesselList',
          'getVesselCrewTons',
          'reset_vessels',
        ],
    ),

    loadData(){
      if(this.vessels.length == 0){
        this.formDataVesselTon.manningId = this.manningId
        this.getVesselList(this.formDataVesselTon);
      }
    },

    setPage(e) {
      this.formDataVesselTon.page = e;
      this.formDataVesselTon.manningId = this.manningId
      this.getVesselList(this.formDataVesselTon);
    },

    callSearchVesselDebounce : __.debounce(function(){
      this.searchVessel();
    },500),

    searchVessel() {
      this.formDataVesselTon.page = 1;
      this.formDataVesselTon.manningId = this.manningId
      this.getVesselList(this.formDataVesselTon);
    },

    viewDetails(objVal) {
      this.formTonPayload.rankId = objVal.rankId
      this.formTonPayload.manningId = this.authUser.manningId ? this.authUser.manningId : null,
      this.formTonPayload.vesselId = objVal.id,
      this.getVesselCrewTons(this.formTonPayload)
      this.$router.push({name: 'CrewTonView',params : this.formTonPayload});
    },
  },

  /**  computed  **/
  computed: {
    ...mapGetters(
        [
          'vessels',
          'objVesselTypeKeys',
          'objManningKeys',
          'vesselPagination',
          'isLoading',
          'counts',
          'authUser',
          'formDataVesselTon',
          'formTonPayload',
        ],
    ),
    manningId () {
     return this.formDataVesselTon.manningId ?   this.formDataVesselTon.manningId :  this.authUser?.manningId
    }
  },

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
    this.loadData();
  },

  watch: {},

  /** destroyed **/
  destroyed() {},
};
</script>

<style scoped>
.list-group-item {
  padding: .25rem .5rem;
}
</style>
